"use strict";
var RentalInformationViewModel = (function () {
    function RentalInformationViewModel() {
    }
    return RentalInformationViewModel;
}());
exports.RentalInformationViewModel = RentalInformationViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverages/rental-information-view.model.js